export const RESULTS_PER_PAGE = 20;
export const UNAUTHORIZED = "UNAUTHORIZED";

export const FORBIDDEN = "FORBIDDEN"
export const REFRESH_TOKEN = "REFRESH_TOKEN"